export default __webpack_public_path__ + "static/media/chart.20a85627.svg";